export const UPDATE_EVENT_DETAILS = '/EventDetails/*/Update';
